(ns basic-components.step-indicator
  (:require
   [frontend.utils :as fu]
   [reagent.core :as r]))

(defn item
  [current-step {:keys [key] :as _step}]
  (let [step-atom (r/atom {})]
    (r/create-class
     {:component-did-update
      (fn [this [_ old-current _old-step]]
        ;; https://cljdoc.org/d/reagent/reagent/1.1.0/doc/tutorials/creating-reagent-components
        ;; r/argv maps more directly to component args vs. r/props & r/children:
        (let [[_ next-current _next-step] (r/argv this)]
          (when (= next-current key)
            (when-let [dom-node (:dom-node @step-atom)]
              (.scrollIntoView dom-node)))))
      :reagent-render
      (fn [current-step {:keys [key content class-name] :as _step}]
        [:div
         {:ref        (fn [e]
                        (when (and e
                                   (not= e (:dom-node @step-atom)))
                          (swap! step-atom assoc :dom-node e)
                          (when (= current-step key)
                            (.scrollIntoView e))))
          :class-name (fu/cs class-name
                             "state-indicator__item"
                             (when (= current-step key)
                               "state-indicator__item--active"))}
         content])})))

(defn view
  [{:keys [current-step steps]}]
  [:div
   {:class "inline-flex max-w-full overflow-auto overflow-y-hidden border border-solid border-base-light-border-paler rounded"}
   (for [step steps
         :let [{:keys [key content class-name]} step]]
     ^{:key (str "step-indicator-element-" key)}
     [item current-step step])])
